'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const SidebarContainer = styled.div`
  width: 255px;
  min-width: 255px;
  max-width: 255px;
  height: 100%;
  padding: ${Spacers.BASE}rem;
  border-right: 1px solid ${(props) => props.theme.colors.adminBorder};
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const NavItem = styled.li<{ $isActive?: boolean }>`
  margin-bottom: ${Spacers.XS}rem;
`;

export const NavButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  border: none;
  border-radius: ${Spacers.XS}rem;
  font-size: ${(props) => props.theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
  background-color: ${(props) =>
    props.$isActive ? props.theme.colors.actionDefault : 'transparent'};
  color: ${(props) =>
    props.$isActive
      ? props.theme.colors.typographyHeadersDark
      : props.theme.colors.typographyHeadersLight};
  box-sizing: border-box;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.actionHover};
    color: ${(props) => props.theme.colors.typographyHeadersDark};
  }

  &:active {
    background-color: ${(props) => props.theme.colors.actionActive};
    color: ${(props) => props.theme.colors.typographyHeadersDark};
  }
`;
